import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../../../firebase';

function AllHostcups() {

    const [cups, setCups] = useState([]);

    useEffect(() => {

        try {
            const hostcupRef = firestore.collection("hostcup");
            hostcupRef.onSnapshot(({docs}) => {
                const cups = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setCups(cups);
            })
        } catch (error) {
            
        }

    }, [])

    return (
        <div>
            {cups?.map((cup, index) => {
                return (
                    <div key={index}>
                        <Link to={`/hostcup/admin/${cup.id}`}>{cup.title}</Link>
                    </div>
                )
            })}
        </div>
    )

}
export default AllHostcups